var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.998,
    height: 40,
    viewBox: "0 0 39.998 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back-arrow",
    transform: "translate(42.251 41.001) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 39.998,
    height: 40,
    rx: 8,
    transform: "translate(2.253 1.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(17.753 14.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-2",
    "data-name": "arrow",
    d: "M279,768a1,1,0,0,1-.706-1.7l4.8-4.8-4.8-4.8a1,1,0,0,1,1.412-1.412l5.5,5.5a1,1,0,0,1,0,1.412l-5.5,5.5A1,1,0,0,1,279,768Z",
    transform: "translate(-277.999 -755)",
    fill: "#09c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.b4ac25665064d7381ca47fca13a0d6c4.svg";
export { ForwardRef as ReactComponent };